/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState, useContext } from 'react';
import NoData from '../../../components/Common/NoData';
import { Button, Tooltip, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import '../styles.css';
import NotificationShimmer from '../../../components/Common/Shimmer/Notifications';
import { getNotifications, updateNotifications } from '../../../containers/actions/notifications';
import { useDispatch, useSelector } from 'react-redux';
import { catchErr, DateDiff } from '../../../libs/HelperContent';
import '../../../UiStyles/RightSlider/styles.css';
import { LanguageContext } from '../../../libs/Context';
import { getNotification, getNotificationRedux } from '../../../redux/UserSessionSlice';
import ProfilePic from '../../../components/Common/ProfilePic';
import useThrottle from '../../../components/Hooks/useThrottle';
import NotificationIcon from '../../../assets/NoDataImages/notification.svg';

const Notifications = (props) =>
{
	const { language } = useContext(LanguageContext);
	const dispatch = useDispatch();
	const notificationData = useSelector((state: any) => state?.mysession?.notification);
	const session = useSelector((state: any) => state?.mysession?.session);
	const nc = useSelector((state: any) => state?.mysession?.notificationCount);

	const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);
	const [ skip, setSkip ] = useState(0);
	const [ filter, setFilter ] = useState('all');
	const [ onLoad, setOnLoad ] = useState(false);
	const [ initialCount, setInitialCount ] = useState(0);
	const [ loading, setLoading ] = useState(!(notificationData?.length > 0));

	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) =>
	{
		setAnchorEl(event.currentTarget);
	};

	const handleCloseMenu = () =>
	{
		setAnchorEl(null);
	};

	const handleClose = () =>
	{
		props?.setNotificationSlider(false);
		props?.setNotifyView({ state: false, data: null });
	};

	const getNotificationData = async () =>
	{
		try
		{
			const nLimit = 10;
			const query = `?skip=${skip}&limit=${nLimit}&status=${filter}`;
			const resp = await getNotifications(query);

			dispatch(getNotificationRedux(skip !== 0
				? [ ...notificationData, ...resp.data.notifications ]
				: resp?.data?.notifications));
			setLoading(false);
			setOnLoad(false);

			if (resp?.data?.notifications?.length < nLimit && skip === 0)
			{
				setInitialCount(resp?.data?.notifications?.length);
			}
			else
			{
				const respCount = await getNotifications(`?status=${filter}&count=true`);

				setInitialCount(respCount?.data?.notificationsCount);
				dispatch(getNotification(respCount?.data?.unreadCount));
			}
		}
		catch (e: any)
		{
			setLoading(false);
			setOnLoad(false);
			console.log(e);
		}
	};

	const onUpdate = async (item, index) =>
	{
		const elem = document.getElementById(item._id);

		elem?.classList.add('whiteBg');

		if (item?.seen)
		{
			if (props?.notifyView?.state && props?.notifyView.data === item)
			{
				props?.setNotifyView({ state: false, data: null });
			}
			else
			{
				props?.setNotifyView({ state: true, data: item });
			}
		}
		else
		{
			try
			{
				const body = { id: item._id };

				props?.setNotifyView({ state: true, data: item });
				if (nc !== 0)
				{
					dispatch(getNotification(nc - 1));
				}
				const newNotificationData = [ ...notificationData ];

				newNotificationData[index] = { ...item, seen: true };
				dispatch(getNotificationRedux(newNotificationData));
				await updateNotifications(body);
				props?.setNotificationStatus((prev: any) => !prev);
			}
			catch (e: any)
			{
				catchErr(e);
			}
		}
	};

	const onFilterChange = (fil) =>
	{
		setSkip(0);
		setFilter(fil);
		setInitialCount(0);
		handleCloseMenu();
	};

	const onClickLoad = () =>
	{
		setOnLoad(true);
		setSkip(skip + 1);
	};

	useEffect(() =>
	{
		getNotificationData();
	}, [ skip, filter ]);

	const handleRead = async () =>
	{
		await updateNotifications({ isReadAll: 'all' });
		dispatch(getNotification(0));
		setSkip(0);
		getNotificationData();
	};

	const unreadTernary = filter === 'unread' ? language.unread : language.all;

	const handleThrotRead = useThrottle(() => handleRead(), 2000);

	return (
		<>
			<div className='flexRow fxdRSliderHdr pdngVSM brdrBSM alignCntr'>
				<div className='flexMinWidthRow pdngHXS subHeadingSM-sub ellipsisTxt-sub'>
					<span className='notify-txt-parent pdngHXS'>{language?.notifications}</span>&nbsp;
					<button
						className='notify-txt-child pdngHXS txt-hover-highlight'
						value='MarkAllasRead'
						onClick={nc > 0 ? handleThrotRead : undefined}
						style={{ fontSize: '14px' }}
					>
						{nc > 0 ? language?.markAllAsRead : language?.markedAsRead }
					</button>
				</div>
				<div className='flexAutoRow pdngHXS'>
					<Button
						id='fade-button'
						size='small'
						tabIndex={0}
						onKeyUp={(e: any) => { e.key === 'Enter' && handleClick(e); }}
						variant='outlined'
						onClick={handleClick}
						className='capitalTxt'
						disableElevation disableRipple
					>
						{filter === 'read' ? language.read : unreadTernary} &nbsp;<ArrowDropDownIcon />
					</Button>
				</div>
				<button
					tabIndex={0}
					onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }}
					className='flexAutoRow justifyEnd pdngHXS pointer'
					onClick={handleClose}
				>
					<Tooltip title={language?.close} placement='top-start' >
						<CloseIcon />
					</Tooltip>
				</button>
			</div>
			{loading && <NotificationShimmer />}
			{!loading && notificationData && notificationData.length > 0 &&
				<>
					{/* <div className='flexMinHeightCol scrollY'> */}
					<button
						tabIndex={0}
						className={'flexRow pdngHXS pointer connectionBrdrNone Notify whiteBg buttonBrd'}
					/>
					{/* </div> */}
					<div className='flexMinHeightCol scrollY'>
						{notificationData?.length > 0 && notificationData?.map((notify, index) => (
							<button
								tabIndex={0}
								className={`flexRow pdngHXS pointer connectionBrdrNone Notify ${notify?.seen && 'whiteBg'} buttonBrd`}
								id={notify._id}
								onKeyUp={(e) => { e.key === 'Enter' && onUpdate(notify, index); }}
								onClick={() => { onUpdate(notify, index); }}
								key={`${notify?.senderId}-${index}`}
							>
								<div className='flexAutoRow pdngXS'>
									<div className='imgAvatarSM brdrBlackSM brdrRadius50'>
										<ProfilePic
											imagePath={`${notify?.role === 'company'
												? `${notify?.creatorProfile?.companyId}_profile.jpeg`
												: `${notify?.creatorProfile?.userId}.jpeg`}?t=${new Date().valueOf()}`}

											defaultImg='/images/icons/defaultUser.svg'
											alt='profile'
											className='brdrRadius50 objectFitContain'
											from={notify?.creatorProfile?.notify?.role === 'company' ? '' : 'selfProfile'}
										/>
									</div>
								</div>
								<div className='flexMinWidthCol pdngXS'>
									<span className='headingSM wordBreakWord firstLetter'>{
										(session?.userId === notify?.senderId)
											? notify?.senderMessage
											: notify?.receiverMessage}</span>
									<div className='flexRow'>
										<span className='lightTxt headingXSM ellipsisTxt'>{DateDiff(notify?.createdAt, new Date().valueOf())}</span>
										{notify?.type === 'License Expired Reminder' && <div className='flexAutoRow'>
											<Button variant='outlined' size='small'>Contact</Button>
										</div>}
									</div>
								</div>
							</button>
						))}
					</div>
					{initialCount > notificationData?.length &&
						<div className='flexRow pdngSM justifyEnd'>
							{!onLoad && (
								<button
									className='flexInline pdngHXS primaryTxt pointer'
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && onClickLoad(); }}
									onClick={onClickLoad}
								>
									<ArrowDownwardIcon fontSize='small' />&nbsp;{language?.load}
								</button>
							)}
							{onLoad && (
								<span className='flexInline pdngHXS primaryTxt pointer'>
									<CircularProgress size={20} />&nbsp;{language?.loading}
								</span>
							)}
						</div>
					}
				</>
			}
			{!loading && notificationData.length === 0 &&
				<div className='flexCol alignCntr justifyCntr mrgnAuto'>
					<NoData noDataHead={language?.noNotifications} noDataPara={language?.upToDate} src={<img src={NotificationIcon}/>} />
				</div>
			}
			<Menu id='fade-menu' MenuListProps={{ 'aria-labelledby': 'fade-button' }} anchorEl={anchorEl} open={open} defaultValue={filter} onClose={handleClose}>
				<MenuItem value='all' onClick={() => { onFilterChange('all'); }}>{language?.all}</MenuItem>
				<MenuItem value='read' onClick={() => { onFilterChange('read'); }}>{language?.read}</MenuItem>
				<MenuItem value='unread' onClick={() => { onFilterChange('unread'); }}>{language?.unread}</MenuItem>
			</Menu>
		</>
	);
};

export default Notifications;
